import React from 'react';

const Logo: React.FC<{ className?: string }> = ({ className = "" }) => {
  return (
    <div className={`flex items-center select-none ${className}`}>
        <img 
          src="/logo.png" 
          alt="Typeo Go Logo" 
          className="h-10 w-auto mr-1" 
        />
        {/* The blinking cursor */}
        <span className="text-3xl font-light text-blue-600 cursor-blink mb-1">|</span>
    </div>
  );
};

export default Logo;